import { PermissionsItem } from "../interfaces/permissions-interface";

export const transformArrToObj = (permissionsList: PermissionsItem[]) => {
  if (!permissionsList) {
    return;
  }

  const permissionsByKey: any = {};
  permissionsList?.forEach(
    (rolePermissionItem: PermissionsItem) =>
      (permissionsByKey[rolePermissionItem.permissionKey] = {
        ...rolePermissionItem,
      })
  );
  return permissionsByKey;
};
